'use strict';

module.exports = require('./es6/crc32').default;



//////////////////
// WEBPACK FOOTER
// ./~/crc/lib/crc32.js
// module id = 645
// module chunks = 0